import React from 'react';
import { motion } from 'framer-motion';
import { Play, Pause, SkipForward, X } from 'lucide-react';

interface WorkoutControlsProps {
  isPaused: boolean;
  onPauseToggle: () => void;
  onSkip?: () => void;
  onEnd: () => void;
}

export function WorkoutControls({ isPaused, onPauseToggle, onSkip, onEnd }: WorkoutControlsProps) {
  return (
    <div className="flex justify-center gap-4">
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onPauseToggle}
        className="theme-button w-32 py-3 rounded-lg flex items-center justify-center gap-2"
      >
        {isPaused ? (
          <>
            <Play className="w-5 h-5" />
            Resume
          </>
        ) : (
          <>
            <Pause className="w-5 h-5" />
            Pause
          </>
        )}
      </motion.button>

      {onSkip && (
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={onSkip}
          className="bg-muted hover:bg-muted/70 w-32 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
        >
          <SkipForward className="w-5 h-5" />
          Skip
        </motion.button>
      )}

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onEnd}
        className="bg-destructive/20 text-destructive hover:bg-destructive/30 w-32 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
      >
        <X className="w-5 h-5" />
        End
      </motion.button>
    </div>
  );
}